import { css } from '@emotion/react'
import styled from '@emotion/styled'

export const Section = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  max-width: 400px;
  width: 200px;
  height: 100%;
  overflow: hidden;
  background-color: #fff;
  border-radius: 4px;
  border: 1px solid #ebebeb;
  font-family: 'Noto Sans', sans-serif;
  transition: all 250ms;
  padding: 10px 0;
`

export const MenuItem = styled.div`
  position: relative;

  &.-all-dataset-menu-item,
  &.-favorites-dataset-menu-item {
    svg {
      path {
        fill: rgba(0, 0, 0, 0.54);
      }
    }

    .Mui-selected svg path {
      fill: #000;
    }
  }

  &.-all-dataset-menu-item svg {
    width: 18px;
  }

  &.-all-dataset-menu-item svg {
    width: 20px;
  }

  .MuiMenuItem-root {
    min-height: auto;
    padding: 5px 15px;

    &.Mui-selected {
      background-color: transparent;
    }

    .MuiListItemIcon-root {
      min-width: 24px;
      margin-right: 5px;
    }
  }

  .MuiListItemText-root {
    font-size: 12px;
    color: rgba(0, 0, 0, 0.54);
  }
`

export const FolderItem = styled.div`
  min-height: auto;
  padding: 0 15px;
  display: flex;

  .MuiTypography-body1 {
    color: #757575;
  }
`

export const Folders = styled.div`
  overflow-y: scroll;
  height: 500px;
`

export const GreenSelectedBar = styled.div`
  background-color: #5dd39e;
  width: 6px;
  height: 100%;
  position: absolute;
  left: 0;
`

export const GreyBar = styled.div`
  border: 1px solid #e0e0e0;
  margin: 10px 15px;
`

export const boldTypography = css`
  font-weight: bold;
`

export const selectedTypography = css`
  font-weight: bold;
  color: #000;
`

export const typography = css`
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  max-width: 132px;
`
